import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="14.98" height="14.98" viewBox="0 0 14.98 14.98">
  <path d="M15.625-14.98a1.786,1.786,0,0,0-1.309.547L7.988-8.125,7.52-5.742l-.2.918.918-.2,2.383-.469,6.309-6.328a1.786,1.786,0,0,0,.547-1.309,1.786,1.786,0,0,0-.547-1.309A1.786,1.786,0,0,0,15.625-14.98Zm0,1.211a.619.619,0,0,1,.43.215.619.619,0,0,1,.215.43.619.619,0,0,1-.215.43L10-6.641l-1.074.215L9.141-7.5,15.2-13.555A.619.619,0,0,1,15.625-13.77ZM2.5-12.5V0H15V-8.242l-1.25,1.25V-1.25h-10v-10H9.492l1.25-1.25Z" transform="translate(-2.5 14.98)"/>
</svg>
  )
